.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}
